/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const settingsRoutes = {
  path: '/settings',
  component: Layout,
  redirect: '/settings',
  name: 'Settings',
  alwaysShow: true,
  meta: {
    title: 'settings',
    icon: 'Tools',
  },
  children: [
    /** Settings managements */
    {
      path: 'pos-settings/update/1',
      component: () => import('@/views/pos-setting/Update'),
      name: 'PosSettingUpdate',
      meta: { title: 'Update Pos Setting', icon: 'edit', permissions: ['pos setting view'] },
    },
    {
      path: 'office-info/update/1',
      component: () => import('@/views/office-info/Update'),
      name: 'OfficeInfoUpdate',
      meta: { title: 'Office Info Update', icon: 'edit', permissions: ['office info view'] },
    }
  ],
};

export default settingsRoutes;
